export const headerFreightTable: string[] = [
  'Cliente',
  'Tipo',
  'Status',
  'Liberado pra expedir',
  'Data limite de entrega',
  'Observações',
]

export const mock = [
  {
    number: 123456,
    type: 'Entrega',
    Status: 'A programar',
    finalDate: '12/12/2024',
    limitDate: '12/12/2025',
    numberHouse: 116,
    client: 'EAGLEBURGMAN',
    cep: '05270080',
    street: 'Rua Marilia',
    neighborhood: 'Bela vista',
    city: 'São Paulo',
    state: 'SP',
    complement: 'Sala 23',
    height: 123,
    lenght: 123,
    width: 123,
    weight: 123,
    cubage: 123,
    details: 'Lorem ipsum dolor sit',
  },
  {
    number: 654321,
    type: 'Coleta',
    Status: 'Concluído',
    finalDate: '01/02/2025',
    limitDate: '10/02/2025',
    numberHouse: 200,
    client: 'ACME CORP',
    cep: '01311000',
    street: 'Avenida Paulista',
    neighborhood: 'Bela Vista',
    city: 'São Paulo',
    state: 'SP',
    complement: 'Apartamento 101',
    height: 150,
    lenght: 200,
    width: 100,
    weight: 300,
    cubage: 400,
    details: 'Produto frágil, manusear com cuidado',
  },
  {
    number: 789012,
    type: 'Entrega',
    Status: 'Em andamento',
    finalDate: '20/11/2024',
    limitDate: '30/11/2024',
    numberHouse: 50,
    client: 'TECH SOLUTIONS',
    cep: '04094000',
    street: 'Rua dos Pinheiros',
    neighborhood: 'Pinheiros',
    city: 'São Paulo',
    state: 'SP',
    complement: 'Loja B',
    height: 120,
    lenght: 80,
    width: 60,
    weight: 250,
    cubage: 160,
    details: 'Entregar até às 18h',
  },
  {
    number: 345678,
    type: 'Coleta',
    Status: 'Pendente',
    finalDate: '05/01/2025',
    limitDate: '15/01/2025',
    numberHouse: 18,
    client: 'GREEN VALLEY',
    cep: '04547006',
    street: 'Rua Joaquim Floriano',
    neighborhood: 'Itaim Bibi',
    city: 'São Paulo',
    state: 'SP',
    complement: 'Prédio azul, Sala 12',
    height: 110,
    lenght: 95,
    width: 45,
    weight: 180,
    cubage: 220,
    details: 'Pacote grande, verifique o acesso',
  },
  {
    number: 901234,
    type: 'Entrega',
    Status: 'Cancelado',
    finalDate: '10/03/2024',
    limitDate: '15/03/2024',
    numberHouse: 350,
    client: 'GOLDEN FOODS',
    cep: '01536000',
    street: 'Rua Vergueiro',
    neighborhood: 'Liberdade',
    city: 'São Paulo',
    state: 'SP',
    complement: 'Restaurante',
    height: 140,
    lenght: 70,
    width: 80,
    weight: 220,
    cubage: 300,
    details: 'Entrega prioritária',
  },
]
